module.exports = __webpack_public_path__ + "media/images/icons/country_flags/cf-a3843e7991ac45d28efffd46408141d2.svg";